import cloneDeep from 'lodash/cloneDeep'
import get from 'lodash/get'

import Utils from './Utils'

class FpSdk {
  constructor () {
    this.modules = require('forepaas.json').modules
    this.Utils = Utils
  }
  initModules () {
    for (let key in this.modules) {
      if (key === 'sdk' || this.modules[key].root) {
        continue
      }
      try {
        this.modules[key.split(':').pop()] = require('forepaas/' + key.replace(/:/g, '_') + '/index').default
      } catch (err) {
        console.error(err)
        delete this.modules[key]
        console.error(`Cannot find module ${key}`)
      }
    }
  }
  getModule (name) {
    if (this.modules[name]) return this.modules[name]
    if (this.modules['core-ui'] && this.modules['core-ui'][name]) { return this.modules['core-ui'][name] }
    return null
  }
  computeVars (expr) {
    try {
      // eslint-disable-next-line no-eval
      return eval(expr)
    } catch (error) {
      console.warn('Failed to evaluate environment expression:', expr, error)
      // Return the original expression if evaluation fails
      return expr
    }
  }
  initConfig (config) {
    if (config) {
      Object.keys(config).forEach((key) => {
        if (typeof config[key] === 'string') {
          if (config[key].indexOf('file://') === 0) {
            let file = config[key].replace('file://config/', '')
            config[key] = require('config/' + file)
          }
          if (typeof config[key] === 'string' && config[key].substr(0, 6) === '{{ENV.' && config[key].substr(-2) === '}}') {
            const result = this.computeVars(config[key].substr(2, config[key].length - 4))
            // If the result is empty or undefined, keep the original expression for debugging
            config[key] = result || config[key]
          }
        }
        if (typeof config[key] === 'object') {
          this.initConfig(config[key])
        }
      })
    }
    return config
  }
  getConfig () {
    return new Promise((resolve, reject) => {
      try {
        let config = cloneDeep(require('config/global.json'));
        if (typeof config.authentication === 'undefined') config.authentication = ''
        if (!config.api) config.api = ''
        if (!config.application_name) config.application_name = 'cloom-app'
        this.config = this.initConfig(config)
        resolve()
      } catch (err) {
        console.error(err)
        reject(new Error('No config file found, please create a file name global.json in the config folder'))
      }
    })
  }

  updateConfig (id, value) {
    let conf = get(this.config, id)
    if (conf) {
      Object.keys(value).forEach(key => {
        conf[key] = value[key]
      })
    }
  }

  init () {
    this.modules.sdk = this.modules.sdk || {}
  }
  start () {
    return this.getConfig()
  }
}

const sdk = new FpSdk()
global.Forepaas = sdk
export default sdk

/* global Forepaas */
Forepaas.initModules()
Forepaas.init()
